import {Component, Inject, OnInit} from '@angular/core';
import {IFormFileUploadDialog} from '../../../../interface/form-structure';
import {HttpFormService} from '../../../../services/formServices';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'noos-add-file',
    templateUrl: './add-file.component.html',
    styleUrls: ['./add-file.component.scss']
})
export class AddFileComponent implements OnInit {

    title = '';

    file: any;
    fileName = '';
    description = '';
    isLoading = false;

    constructor(public dialogRef: MatDialogRef<AddFileComponent>,
                @Inject(MAT_DIALOG_DATA) public data: IFormFileUploadDialog,
                private formService: HttpFormService) {
    }

    ngOnInit() {

        this.title = this.data.fileCategoryItem ? this.data.fileCategoryItem.file_category_name : 'Diğer';

    }

    selectFile(files: FileList) {
        const file: File = files.item(0);

        if (files && file) {
            const myReader: FileReader = new FileReader();
            myReader.onloadend = (e) => {
                this.file = myReader.result;
            };
            myReader.readAsDataURL(file);
            this.fileName = file.name;
        }

    }

    getID() {
        return Math.random().toString(36).substr(2, 9) + '-' +
            Math.random().toString(36).substr(2, 9);
    }

    onAddFile() {

        if (this.file) {
            /*
            const formData = new FormData();
            formData.append('file', this.file);
            formData.append('original_file_name', this.fileName);
            formData.append('note', this.description);
            formData.append('dataset_record_id', this.data.DATASET_ID);
            formData.append('client_id', this.data.FORM_ID);
            formData.append('_id', this.data.FORM_ID);
            formData.append('client_form_id', this.data.FORM_GUID);
            formData.append('file_type_id', this.data.fileCategoryItem ? this.data.fileCategoryItem.file_category_code : '');
             */

            const body = {
                file: this.file,
                dataset_id: this.data.DATASET_ID,
                dataset_record_id: this.data.FORM_ID,
                client_id: this.getID(),
                client_form_id: this.data.FORM_GUID,
                original_file_name: this.fileName,
                note: this.description,
                _id: this.data.FORM_ID,
                file_type_id: this.data.fileCategoryItem ? this.data.fileCategoryItem.file_category_code : ''
            };
            this.isLoading = true;
            this.formService.uploadFile(body).subscribe(ret => {
                if (ret.complete) {
                    this.data.formFileData.push(
                        {
                            file_link: ret.data.file_link,
                            file_name: ret.data.file_name,
                            file_extension: ret.data.file_extension,
                            file_size: ret.data.file_size,
                            original_file_name: ret.data.original_file_name,
                            file_type_id: ret.data.file_type_id,
                            id: ret.mdid
                        }
                    );
                    this.dialogRef.close(this.data);
                }
                this.isLoading = false;
            });

        }

    }

    onClose() {
        this.dialogRef.close();
    }

    fileChangeEvent(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            reader.onloadend = (e) => {
                this.file = reader.result;
            };
            reader.readAsDataURL(fileInput.target.files[0]);
            this.fileName = fileInput.target.files[0].name;
        }
    }
}
